<template>
    <span class="tag-wrap">
        <div v-if="!dealer" :class="isBanker ? 'tag-z' : 'tag-v'">
            {{ isBanker ? $t('goldenFlower.banker') : `V${lv ?? '0'}` }}
        </div>
        <span class="name">
            {{ userName }}
        </span>
        <span v-if="Number(balance) > 0" class="balance truncate px-1">
            {{ getFixed(balance) }}
        </span>
    </span>
</template>

<script lang="ts" setup> 

const props = defineProps({
    userName: {
        type: String,
        required: true, 
    },
    balance: {
        type: String,
    },
    countingDown: {
        type: Number,
    },
    isBanker: {
        type: Boolean,
    },
    dealer: {
        type: Boolean,
    },
    isRound: {
        type: Boolean,
    },
    lv: {
        type: Number,
    }
});

// 倒计时功能已移除

</script>

<style lang="scss" scoped>

.tag-wrap{
    background: linear-gradient(180deg, #2F2F2F 0%, #151818 100%); 
    // width: 65px;
    width: var(--name-tag-width);
    min-height: 22px;
    opacity: 1;
    border-radius: 6px;
    display: inline-flex; 
    flex-direction: column; 
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    position: relative; 
}
.tag-v,
.tag-z {
    box-shadow: 0px 0px 2px 0px #FFFFFF40 inset;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    right: 0;
    position: absolute;
    top: -8px;
    font-weight: 300;
    font-size: 10px;
    text-align: center;
}
.tag-z {
    background: linear-gradient(180deg, #B830B4 0%, #711B7C 100%);

}
.tag-v {
    background: linear-gradient(180deg, #3BB830 0%, #277C1B 100%);
}
.name,
.balance{
    height: 22px; 
    line-height: 22px; 
    text-align: center;

}

.name{
    display: inline-block; 
    font-weight: 400;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding: 0 8px; 
    white-space: nowrap; 
}

.balance{
    width: 100%; 
    color: rgba(253, 217, 53, 1);
    font-weight: 400;
    font-size: 12px;
    position: relative; 
    // vertical-align: middle;
    &:before{
        content: '';
        width: 90%; 
        height: 1px;
        display: block;
        position: absolute;  
        top: 0;
        left: 5%;
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);
        opacity: 0.3; 
    }
}

/* 倒计时样式已移除 */

</style>
